import { schema } from "normalizr";
import { Chargeback as ChargebackRecord } from "records/payments";

export const Chargeback = new schema.Entity(
    "chargeback",
    {},
    {
        idAttribute: "id",
    }
);

(Chargeback as any).record = ChargebackRecord;
